import styled, { css } from 'styled-components/macro';

import HeadingBase from '@components/common/core/DataDisplay/Heading';
import { EHeadAlign } from '@domain/enums/components/ETable';

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 48px;
`;

export const Title = styled(HeadingBase)``;

export const Body = styled.div``;

export const ProductName = styled(HeadingBase)`
  margin-bottom: 32px;
`;

export const TableWrapper = styled.div`
  padding: 0;
  overflow-x: scroll;

  &::-webkit-scrollbar {
    height: 6px;
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.background[5]};
    border-radius: 25px;
    margin-bottom: 4px;
  }
`;

export const Table = styled.table`
  width: 100%;
  min-width: max-content;
  border-collapse: collapse;
`;

export const TableHeader = styled.thead``;

export const TableHead = styled.th`
  text-align: left;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: 500;
  font-size: 1.125rem;
  color: ${({ theme }) => theme.colors.font};
  padding: 0 12px 18px 12px;

  &:first-child {
    padding-left: 0px;
  }

  ${({ align }) =>
    align === EHeadAlign.CENTER &&
    css`
      text-align: center;
    `};

  ${({ align }) =>
    align === EHeadAlign.RIGHT &&
    css`
      text-align: right;
    `};
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr``;

export const TableData = styled.td`
  text-align: left;
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.font};
  font-weight: 400;
  padding: 0 12px 24px 12px;

  &:first-child {
    padding-left: 0px;
  }

  ${({ align }) =>
    align === EHeadAlign.CENTER &&
    css`
      text-align: center;
    `};

  ${({ align }) =>
    align === EHeadAlign.RIGHT &&
    css`
      text-align: right;
    `};
`;

export const TableFooter = styled.tfoot``;
